<template>
    <div>
        <div class="flex flex-col justify-between space-y-6 sm:flex-row sm:items-center sm:space-y-0">
            <PaginationShowing v-if="meta.total" :meta="meta"/>
            <div class="form-group sm:ml-auto">
                <Input
                    class="form-input w-full block"
                    v-model="search"
                    :clearable="true"
                    placeholder="Search..."/>
            </div>
        </div>

        <slot></slot>

        <PaginationLinks
            v-if="meta.total"
            :meta="meta"
            @change="onPageChange"
            class="mt-6"/>
    </div>
</template>

<script>

import PaginationLinks from "@/Components/PaginationLinks";
import Input from "@/Components/Form/Input";
import PaginationShowing from "@/Components/PaginationShowing";
import PaginationHelpers from "@/Mixins/PaginationHelpers";
import {debounce} from "lodash";

export default {

    name: "Pagination Wrapper",

    mixins: [PaginationHelpers],

    props: {
        rows: {
            type: Array,
            required: true
        },
        meta: {
            type: Object,
            required: true
        },
        constraints: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            search: this.constraints.search || '',
        }
    },

    components: {
        PaginationLinks,
        Input,
        PaginationShowing,
    },

    watch: {
        search: debounce(function (search) {
            this.getData(_.merge(this.constraints, {search, page: null}));
        }, 200),
    }
};

</script>
